export const actionTypes = {
    GET_USER_LIMITS: 'operationalParameters/GET_USER_LIMITS',
    GET_PLOT_KPIS: 'detailedInformation/userLimits/GET_PLOT_KPIS',
    CLEAR_STORE: 'detailedInformation/userLimits/CLEAR_STORE',
    SAVE_USER_LIMITS: 'detailedInformation/userLimits/SAVE_USER_LIMITS'
};

export const MAX_LENGTH_USER_LIMIT_NAME = 60;
